/* eslint-disable linebreak-style */
/*
 * @FileName: Do not edit
 * @Date: 2022-02-11 10:07:54
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-09 10:01:45
 * @FilePath: \mobile-portal\src\lang\inner\zh-CN\form.js
 */
export default {
  form: {
    reject: 'Reject',
    confirm: 'Confirm',
    approval: 'Approval',
    close: 'Close',
    err1:'NO Data',
    success1: 'Uploaded Successfully',
    add:'Upload attachments',
    successful:'Submit Successfully',
    loginSuccessful:'Login Successfully',
    msgFileErr: '上传文件格式不符合',
  },
};
